import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import { closeTooltip } from "../actions";

export function* investTechPointSaga({ technologyId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "investTechPoint",
      technologyId
    });

    const { data } = JSON.parse(response.data);
    const {
      development,
      famine,
      slotPrices,
      resources,
      resourceBalances,
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      magicResearch,
      generals,
      population,
      slotChains,
      allBuildings,
      army,
      armyFormation
    } = data;

    yield put(actions.updateResources({
      resources,
      resourceBalances
    }));

    yield put(actions.updateDevelopment(development));

    yield put(actions.updateState({
      famine
    }));

    if (slotPrices) {
      yield put(actions.updateState({
        slotPrices
      }));
    }

    if (slotChains) {
      yield put(actions.updateState({
        slotChains,
        allBuildings
      }));
    }

    if (army) {
      yield put(actions.updateState({
        army,
        armyFormation
      }));
    }

    if (hasFinishedQuest) {
      yield put(actions.updateState({
        hasFinishedQuest,
        availableQuests,
        finishedQuests,
        magicResearch,
        generals,
        population
      }));
    }

    yield put(closeTooltip("TechnologyStepInfo"));
  } catch (error) {
    console.log(error.message);
  }
}
